import { render, staticRenderFns } from "./Carriers.vue?vue&type=template&id=686bd9f5&scoped=true"
import script from "./Carriers.vue?vue&type=script&lang=js"
export * from "./Carriers.vue?vue&type=script&lang=js"
import style0 from "./Carriers.vue?vue&type=style&index=0&id=686bd9f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686bd9f5",
  null
  
)

export default component.exports